// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* g:\\COGNITIVE\\Dev\\3f\\3f-deepgaze-react\\app\\src\\components\\Login\\Login.css */

.login-page {
    font-family: 'Outfit', sans-serif;
    background: radial-gradient(circle at top right, #3c4b64 0%, #1a222f 100%);
    position: relative;
    overflow: hidden;
}

/* Animated background elements */
.login-page::before {
    content: '';
    position: absolute;
    width: 500px;
    height: 500px;
    background: rgba(60, 75, 100, 0.2);
    border-radius: 50%;
    top: -250px;
    right: -100px;
    filter: blur(80px);
    z-index: 0;
}

.login-page::after {
    content: '';
    position: absolute;
    width: 400px;
    height: 400px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    bottom: -200px;
    left: -50px;
    filter: blur(80px);
    z-index: 0;
}

.login-card-container {
    z-index: 1;
    background: rgba(255, 255, 255, 0.98) !important;
    backdrop-filter: blur(10px);
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5) !important;
    border-radius: 24px !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    animation: slideUp 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.login-form-side {
    padding: 3.5rem !important;
}

.login-input-group {
    margin-bottom: 1.25rem;
}

.login-label {
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.7rem;
    letter-spacing: 1.2px;
    color: #6c757d;
    margin-bottom: 0.6rem;
}

.login-input {
    border-radius: 12px !important;
    padding: 0.85rem 1.1rem !important;
    border: 2px solid #f1f3f5 !important;
    background: #f8f9fa !important;
    color: #212529 !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    font-weight: 500;
}

.login-input:focus {
    border-color: #3c4b64 !important;
    background: white !important;
    box-shadow: 0 0 0 4px rgba(60, 75, 100, 0.1) !important;
    transform: translateY(-1px);
}

.btn-primary-login {
    border-radius: 14px !important;
    padding: 1rem !important;
    font-weight: 700 !important;
    font-size: 1rem !important;
    background: linear-gradient(135deg, #3c4b64 0%, #2a3649 100%) !important;
    border: none !important;
    box-shadow: 0 10px 20px -5px rgba(60, 75, 100, 0.4) !important;
    transition: all 0.3s ease !important;
}

.btn-primary-login:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 30px -5px rgba(60, 75, 100, 0.5) !important;
}

.btn-primary-login:active {
    transform: translateY(-1px);
}

.login-image-side {
    position: relative;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
}

.login-image-side .overlay-content {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 3rem;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%);
    border-bottom-right-radius: 24px;
}

.login-tag {
    background: rgba(60, 75, 100, 0.1);
    color: #3c4b64;
    padding: 0.4rem 1rem;
    border-radius: 50px;
    font-size: 0.75rem;
    font-weight: 700;
    display: inline-block;
    margin-bottom: 1.5rem;
}

.login-version {
    color: #adb5bd;
    font-size: 0.7rem;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-top: 2rem;
    opacity: 0.6;
}

/* Animations labels */
.login-input-group label {
    transition: color 0.3s ease;
}

.login-input-group:focus-within label {
    color: #3c4b64;
}

@media (max-width: 768px) {
    .login-form-side {
        padding: 2.5rem !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAI7E;IACI,iCAAiC;IACjC,0EAA0E;IAC1E,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,gDAAgD;IAChD,2BAA2B;IAC3B,2DAA2D;IAC3D,8BAA8B;IAC9B,qDAAqD;IACrD,qDAAqD;AACzD;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,kCAAkC;IAClC,oCAAoC;IACpC,8BAA8B;IAC9B,yBAAyB;IACzB,4DAA4D;IAC5D,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;IAC5B,uDAAuD;IACvD,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,2BAA2B;IAC3B,0BAA0B;IAC1B,wEAAwE;IACxE,uBAAuB;IACvB,8DAA8D;IAC9D,oCAAoC;AACxC;;AAEA;IACI,2BAA2B;IAC3B,8DAA8D;AAClE;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,4EAA4E;IAC5E,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;AAEA,sBAAsB;AACtB;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["/* g:\\COGNITIVE\\Dev\\3f\\3f-deepgaze-react\\app\\src\\components\\Login\\Login.css */\n\n@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700&display=swap');\n\n.login-page {\n    font-family: 'Outfit', sans-serif;\n    background: radial-gradient(circle at top right, #3c4b64 0%, #1a222f 100%);\n    position: relative;\n    overflow: hidden;\n}\n\n/* Animated background elements */\n.login-page::before {\n    content: '';\n    position: absolute;\n    width: 500px;\n    height: 500px;\n    background: rgba(60, 75, 100, 0.2);\n    border-radius: 50%;\n    top: -250px;\n    right: -100px;\n    filter: blur(80px);\n    z-index: 0;\n}\n\n.login-page::after {\n    content: '';\n    position: absolute;\n    width: 400px;\n    height: 400px;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 50%;\n    bottom: -200px;\n    left: -50px;\n    filter: blur(80px);\n    z-index: 0;\n}\n\n.login-card-container {\n    z-index: 1;\n    background: rgba(255, 255, 255, 0.98) !important;\n    backdrop-filter: blur(10px);\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5) !important;\n    border-radius: 24px !important;\n    border: 1px solid rgba(255, 255, 255, 0.3) !important;\n    animation: slideUp 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes slideUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.login-form-side {\n    padding: 3.5rem !important;\n}\n\n.login-input-group {\n    margin-bottom: 1.25rem;\n}\n\n.login-label {\n    font-weight: 600;\n    text-transform: uppercase;\n    font-size: 0.7rem;\n    letter-spacing: 1.2px;\n    color: #6c757d;\n    margin-bottom: 0.6rem;\n}\n\n.login-input {\n    border-radius: 12px !important;\n    padding: 0.85rem 1.1rem !important;\n    border: 2px solid #f1f3f5 !important;\n    background: #f8f9fa !important;\n    color: #212529 !important;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n    font-weight: 500;\n}\n\n.login-input:focus {\n    border-color: #3c4b64 !important;\n    background: white !important;\n    box-shadow: 0 0 0 4px rgba(60, 75, 100, 0.1) !important;\n    transform: translateY(-1px);\n}\n\n.btn-primary-login {\n    border-radius: 14px !important;\n    padding: 1rem !important;\n    font-weight: 700 !important;\n    font-size: 1rem !important;\n    background: linear-gradient(135deg, #3c4b64 0%, #2a3649 100%) !important;\n    border: none !important;\n    box-shadow: 0 10px 20px -5px rgba(60, 75, 100, 0.4) !important;\n    transition: all 0.3s ease !important;\n}\n\n.btn-primary-login:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 15px 30px -5px rgba(60, 75, 100, 0.5) !important;\n}\n\n.btn-primary-login:active {\n    transform: translateY(-1px);\n}\n\n.login-image-side {\n    position: relative;\n    border-top-right-radius: 24px;\n    border-bottom-right-radius: 24px;\n}\n\n.login-image-side .overlay-content {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    padding: 3rem;\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, transparent 100%);\n    border-bottom-right-radius: 24px;\n}\n\n.login-tag {\n    background: rgba(60, 75, 100, 0.1);\n    color: #3c4b64;\n    padding: 0.4rem 1rem;\n    border-radius: 50px;\n    font-size: 0.75rem;\n    font-weight: 700;\n    display: inline-block;\n    margin-bottom: 1.5rem;\n}\n\n.login-version {\n    color: #adb5bd;\n    font-size: 0.7rem;\n    letter-spacing: 2px;\n    text-transform: uppercase;\n    margin-top: 2rem;\n    opacity: 0.6;\n}\n\n/* Animations labels */\n.login-input-group label {\n    transition: color 0.3s ease;\n}\n\n.login-input-group:focus-within label {\n    color: #3c4b64;\n}\n\n@media (max-width: 768px) {\n    .login-form-side {\n        padding: 2.5rem !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
